export enum Url {
    userProfile = '/user/profile',
    otpConnector = '/otp-connector/',
    kycConnector = 'kyc-connector',
    userLogin = '/users/login',
    resetPassword = '/users/sub/forget-passoword',
    resetPasswordWithoutLogin = '/users/forget-passoword',
    subAccountList = '/users/sub-profile/list/',
    bulkActiveInactiveUsersStatus = '/users/update/bulk/users/status',
    users = '/users/',
    usersProfile = '/users/profile/',
    kycStatusList = '/kyc-connector/kyc/list/',
    getOTPConstants = '/configuration/otp/getDetails',
    updateOTPConstants = '/configuration/otp/update/profile',
    getKYCConstants = '/configuration/kyc/getDetails',
    updateKYCConstants = '/configuration/kyc/update/profile'

}
